export const NC = "Non calcolabile";

export const fmtEur = (v, digits = 2) =>
  v === null || v === undefined || Number.isNaN(Number(v))
    ? NC
    : new Intl.NumberFormat("de-DE", { style: "currency", currency: "EUR", minimumFractionDigits: digits, maximumFractionDigits: digits }).format(Number(v));

// de-DE usa gli stessi separatori italiani (1.234,56) ma raggruppa sempre le migliaia (it-IT non raggruppa sotto 10.000)
export const fmtNum = (v, digits = 2) =>
  v === null || v === undefined || Number.isNaN(Number(v))
    ? NC
    : new Intl.NumberFormat("de-DE", { minimumFractionDigits: digits, maximumFractionDigits: digits }).format(Number(v));

export const fmtPct = (v, digits = 2) => (v === null || v === undefined || Number.isNaN(Number(v)) ? NC : `${fmtNum(Number(v) * 100, digits)} %`);

export const fmtDate = (v) => {
  if (!v) return "—";
  const d = new Date(String(v).slice(0, 10) + "T00:00:00");
  return Number.isNaN(d.getTime()) ? "—" : d.toLocaleDateString("it-IT", { day: "2-digit", month: "2-digit", year: "numeric", timeZone: "Europe/Rome" });
};

export const fmtDateTime = (v) => (v ? new Date(v).toLocaleString("it-IT", { timeZone: "Europe/Rome" }) : "—");
export const fmtMonth = (v) => (v ? new Date(String(v).slice(0, 10) + "T00:00:00").toLocaleDateString("it-IT", { month: "short", year: "numeric" }) : "—");

export const label = (v) => (v ? String(v).replace(/_/g, " ").replace(/^\w/, (c) => c.toUpperCase()) : "—");

export const STATUS_COLORS = {
  bozza: "badge-na", in_valutazione: "badge-warn", deliberata: "badge-ok", in_acquisizione: "badge-warn", in_lavorazione: "badge-warn", in_vendita: "badge-ok",
  completata: "badge-ok", sospesa: "badge-na", annullata: "badge-err", approvata: "badge-ok", chiusa: "badge-na", riaperta: "badge-warn",
  OK: "badge-ok", "Da verificare": "badge-warn", "Non calcolabile": "badge-na", pagato: "badge-ok", incassato: "badge-ok", parziale: "badge-warn", scaduto: "badge-err",
  previsto: "badge-na", ricevuto: "badge-warn", annullato: "badge-err", venduta: "badge-ok", disponibile: "badge-na", in_trattativa: "badge-warn", preliminare: "badge-warn",
  aperta: "badge-warn", completata_task: "badge-ok", da_fare: "badge-na", in_corso: "badge-warn", alta: "badge-err", media: "badge-warn", bassa: "badge-na",
};
